<template>
  <div class="yzm-picture">
    <div v-if="item.setting.layoutType === 1" class="yzm-picture__picture1" :style="{ ...marginStyle }">
      <el-image
        :style="{ ...borderStyle, marginTop: index === 0 ? 0 : `${item.setting.itemSpace}px` }"
        v-for="(img, index) in item.data"
        :src="img.imgUrl"
        :key="index"
        fit="cover"
        @click="handleGoTo(item.link)"
      />
    </div>
    <div v-if="item.setting.layoutType === 2" class="yzm-picture__picture2 flex" :style="{ ...marginStyle }">
      <el-image
        class="flex-1"
        :style="{ ...borderStyle, marginLeft: index === 0 ? 0 : `${item.setting.itemSpace}px` }"
        v-for="(img, index) in item.data"
        :src="img.imgUrl"
        :key="index"
        fit="cover"
        @click="handleGoTo(item.link)"
      />
    </div>

    <div v-if="item.setting.layoutType === 3" class="yzm-picture__picture3 flex" :style="{ ...marginStyle }">
      <el-image
        :src="item.data[0].imgUrl"
        :style="{ ...borderStyle, marginRight: `${item.setting.itemSpace}px` }"
        fit="cover"
        @click="handleGoTo(item.link)"
      />
      <div class="flex flex-column" style="width: 50%">
        <el-image
          :src="item.data[1].imgUrl"
          :style="{ ...borderStyle, marginBottom: `${item.setting.itemSpace}px`, height: '50%' }"
          fit="cover"
          @click="handleGoTo(item.link)"
        />
        <el-image
          fit="cover"
          :src="item.data[2].imgUrl"
          :style="{ ...borderStyle, height: '50%' }"
          @click="handleGoTo(item.link)"
        />
      </div>
    </div>
    <div v-if="item.setting.layoutType === 4" class="yzm-picture__picture4 flex flex-wrap" :style="{ ...marginStyle }">
      <div class="flex" style="width: 100%">
        <el-image
          :src="item.data[0].imgUrl"
          :style="{
            ...borderStyle,
            marginRight: `${item.setting.itemSpace}px`,
            marginBottom: `${item.setting.itemSpace}px`
          }"
          fit="cover"
          @click="handleGoTo(item.link)"
        />
        <el-image
          :src="item.data[1].imgUrl"
          :style="{ ...borderStyle, marginBottom: `${item.setting.itemSpace}px` }"
          fit="cover"
          @click="handleGoTo(item.link)"
        />
      </div>
      <div class="flex" style="width: 100%">
        <el-image
          :src="item.data[2].imgUrl"
          :style="{
            ...borderStyle,
            marginRight: `${item.setting.itemSpace}px`
          }"
          fit="cover"
          @click="handleGoTo(item.link)"
        />
        <el-image fit="cover" :src="item.data[3].imgUrl" :style="{ ...borderStyle }" @click="handleGoTo(item.link)" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { defineProps, computed, onMounted, defineEmits } from 'vue'
import { defaultProps } from './defaultProps'
const props = defineProps({
  ...defaultProps
})
const marginStyle = computed(() => {
  let item = props.item.setting
  return {
    marginTop: `${item.marginTop}px`,
    marginBottom: `${item.marginBottom}px`,
    marginLeft: `${item.marginLeft}px`,
    marginRight: `${item.marginRight}px`
  }
})
const borderStyle = computed(() => {
  let item = props.item.setting
  return {
    borderTopLeftRadius: `${item.borderTopLeftRadius}px`,
    borderBottomLeftRadius: `${item.borderBottomLeftRadius}px`,
    borderTopRightRadius: `${item.borderTopRightRadius}px`,
    borderBottomRightRadius: `${item.borderBottomRightRadius}px`
  }
})
const handleGoTo = (url) => {
  window.open(url, '__blank')
}
const emit = defineEmits(['childMounted'])
onMounted(() => {
  emit('childMounted')
})
</script>
<style lang="less" scoped>
.yzm-picture {
  &__picture1 {
    :deep(.el-image) {
      width: 100%;
    }
    :deep(.el-image__error) {
      min-height: 128px;
    }
  }
  &__picture2 {
    :deep(.el-image) {
      height: 128px;
    }
  }
  &__picture3 {
    :deep(> .el-image:nth-child(1)) {
      width: 50%;
      min-height: 128px;
    }
  }
  &__picture4 {
    :deep(.el-image) {
      width: 50%;
      height: 128px;
    }
  }
}
</style>
